module.exports = __webpack_public_path__ + "img/28_72.581607c1.png";